var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMobileApplicationQrCode = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 164,
  height: 164,
  viewBox: "0 0 164 164",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_549_2105)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M163.885 0.751953H0.884766V163.752H163.885V0.751953Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 6.78894H6.92188V12.826H12.9589V6.78894Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.996 6.78894H12.959V12.826H18.996V6.78894Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0331 6.78894H18.9961V12.826H25.0331V6.78894Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 6.78882H25.0332V12.8259H31.0702V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 6.78882H31.0703V12.8259H37.1074V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.1445 6.78882H37.1074V12.8259H43.1445V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 6.78882H43.1445V12.8259H49.1816V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2558 6.78882H55.2188V12.8259H61.2558V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 6.78882H61.2559V12.8259H67.2929V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.33 6.78882H67.293V12.8259H73.33V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.3671 6.78882H73.3301V12.8259H79.3671V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 6.78882H91.4395V12.8259H97.4765V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 6.78882H103.514V12.8259H109.551V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 6.78882H115.588V12.8259H121.625V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.662 6.78882H121.625V12.8259H127.662V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 6.78882H127.662V12.8259H133.699V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.736 6.78882H133.699V12.8259H139.736V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.773 6.78882H139.736V12.8259H145.773V6.78882Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.81 6.78894H145.773V12.826H151.81V6.78894Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 6.78894H151.811V12.826H157.848V6.78894Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 12.8263H6.92188V18.8633H12.9589V12.8263Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 12.8262H43.1445V18.8632H49.1816V12.8262Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.3671 12.8262H73.3301V18.8632H79.3671V12.8262Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4042 12.8262H79.3672V18.8632H85.4042V12.8262Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 12.8262H103.514V18.8632H109.551V12.8262Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 12.8262H115.588V18.8632H121.625V12.8262Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 12.8263H151.811V18.8633H157.848V12.8263Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 18.8632H6.92188V24.9002H12.9589V18.8632Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0331 18.8632H18.9961V24.9002H25.0331V18.8632Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 18.8633H25.0332V24.9003H31.0702V18.8633Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 18.8633H31.0703V24.9003H37.1074V18.8633Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 18.8633H43.1445V24.9003H49.1816V18.8633Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 18.8633H61.2559V24.9003H67.2929V18.8633Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.3671 18.8633H73.3301V24.9003H79.3671V18.8633Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.4394 18.8633H85.4023V24.9003H91.4394V18.8633Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 18.8633H91.4395V24.9003H97.4765V18.8633Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 18.8633H115.588V24.9003H121.625V18.8633Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 18.8633H127.662V24.9003H133.699V18.8633Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.736 18.8633H133.699V24.9003H139.736V18.8633Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.773 18.8633H139.736V24.9003H145.773V18.8633Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 18.8632H151.811V24.9002H157.848V18.8632Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 24.9001H6.92188V30.9372H12.9589V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0331 24.9001H18.9961V30.9372H25.0331V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 24.9001H25.0332V30.9372H31.0702V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 24.9001H31.0703V30.9372H37.1074V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 24.9001H43.1445V30.9372H49.1816V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.33 24.9001H67.293V30.9372H73.33V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.3671 24.9001H73.3301V30.9372H79.3671V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.4394 24.9001H85.4023V30.9372H91.4394V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 24.9001H91.4395V30.9372H97.4765V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.514 24.9001H97.4766V30.9372H103.514V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 24.9001H103.514V30.9372H109.551V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 24.9001H115.588V30.9372H121.625V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 24.9001H127.662V30.9372H133.699V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.736 24.9001H133.699V30.9372H139.736V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.773 24.9001H139.736V30.9372H145.773V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 24.9001H151.811V30.9372H157.848V24.9001Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 30.9369H6.92188V36.9739H12.9589V30.9369Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0331 30.9369H18.9961V36.9739H25.0331V30.9369Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 30.9368H25.0332V36.9738H31.0702V30.9368Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 30.9368H31.0703V36.9738H37.1074V30.9368Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 30.9368H43.1445V36.9738H49.1816V30.9368Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.33 30.9368H67.293V36.9738H73.33V30.9368Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.3671 30.9368H73.3301V36.9738H79.3671V30.9368Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4042 30.9368H79.3672V36.9738H85.4042V30.9368Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.4394 30.9368H85.4023V36.9738H91.4394V30.9368Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 30.9368H103.514V36.9738H109.551V30.9368Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 30.9368H115.588V36.9738H121.625V30.9368Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 30.9368H127.662V36.9738H133.699V30.9368Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.736 30.9368H133.699V36.9738H139.736V30.9368Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.773 30.9368H139.736V36.9738H145.773V30.9368Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 30.9369H151.811V36.9739H157.848V30.9369Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 36.9742H6.92188V43.0113H12.9589V36.9742Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 36.9744H43.1445V43.0114H49.1816V36.9744Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 36.9744H61.2559V43.0114H67.2929V36.9744Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.3671 36.9744H73.3301V43.0114H79.3671V36.9744Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 36.9744H103.514V43.0114H109.551V36.9744Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 36.9744H115.588V43.0114H121.625V36.9744Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 36.9742H151.811V43.0113H157.848V36.9742Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 43.0112H6.92188V49.0483H12.9589V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.996 43.0112H12.959V49.0483H18.996V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0331 43.0112H18.9961V49.0483H25.0331V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 43.0112H25.0332V49.0483H31.0702V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 43.0112H31.0703V49.0483H37.1074V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.1445 43.0112H37.1074V49.0483H43.1445V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 43.0112H43.1445V49.0483H49.1816V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2558 43.0112H55.2188V49.0483H61.2558V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.33 43.0112H67.293V49.0483H73.33V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4042 43.0112H79.3672V49.0483H85.4042V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 43.0112H91.4395V49.0483H97.4765V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 43.0112H103.514V49.0483H109.551V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 43.0112H115.588V49.0483H121.625V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.662 43.0112H121.625V49.0483H127.662V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 43.0112H127.662V49.0483H133.699V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.736 43.0112H133.699V49.0483H139.736V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.773 43.0112H139.736V49.0483H145.773V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.81 43.0112H145.773V49.0483H151.81V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 43.0112H151.811V49.0483H157.848V43.0112Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2558 49.0483H55.2188V55.0854H61.2558V49.0483Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 49.0483H61.2559V55.0854H67.2929V49.0483Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4042 49.0483H79.3672V55.0854H85.4042V49.0483Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.4394 49.0483H85.4023V55.0854H91.4394V49.0483Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 49.0483H91.4395V55.0854H97.4765V49.0483Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 49.0483H103.514V55.0854H109.551V49.0483Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 55.0853H6.92188V61.1224H12.9589V55.0853Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.996 55.0853H12.959V61.1224H18.996V55.0853Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 55.0852H25.0332V61.1222H31.0702V55.0852Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 55.0852H31.0703V61.1222H37.1074V55.0852Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 55.0852H43.1445V61.1222H49.1816V55.0852Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 55.0852H61.2559V61.1222H67.2929V55.0852Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4042 55.0852H79.3672V61.1222H85.4042V55.0852Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 55.0852H91.4395V61.1222H97.4765V55.0852Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.514 55.0852H97.4766V61.1222H103.514V55.0852Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 55.0852H115.588V61.1222H121.625V55.0852Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 55.0853H151.811V61.1224H157.848V55.0853Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.996 61.1224H12.959V67.1595H18.996V61.1224Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 61.1226H31.0703V67.1596H37.1074V61.1226Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.2187 61.1226H49.1816V67.1596H55.2187V61.1226Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.33 61.1226H67.293V67.1596H73.33V61.1226Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.4394 61.1226H85.4023V67.1596H91.4394V61.1226Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 61.1226H91.4395V67.1596H97.4765V61.1226Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.514 61.1226H97.4766V67.1596H103.514V61.1226Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.662 61.1226H121.625V67.1596H127.662V61.1226Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 61.1226H127.662V67.1596H133.699V61.1226Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.736 61.1226H133.699V67.1596H139.736V61.1226Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.773 61.1226H139.736V67.1596H145.773V61.1226Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.81 61.1224H145.773V67.1595H151.81V61.1224Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 67.1594H6.92188V73.1965H12.9589V67.1594Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 67.1594H31.0703V73.1965H37.1074V67.1594Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 67.1594H43.1445V73.1965H49.1816V67.1594Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.2187 67.1594H49.1816V73.1965H55.2187V67.1594Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2558 67.1594H55.2188V73.1965H61.2558V67.1594Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 67.1594H61.2559V73.1965H67.2929V67.1594Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4042 67.1594H79.3672V73.1965H85.4042V67.1594Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 67.1594H91.4395V73.1965H97.4765V67.1594Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.514 67.1594H97.4766V73.1965H103.514V67.1594Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 67.1594H115.588V73.1965H121.625V67.1594Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.736 67.1594H133.699V73.1965H139.736V67.1594Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 67.1594H151.811V73.1965H157.848V67.1594Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 73.1965H6.92188V79.2336H12.9589V73.1965Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0331 73.1965H18.9961V79.2336H25.0331V73.1965Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 73.1965H25.0332V79.2336H31.0702V73.1965Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 73.1965H31.0703V79.2336H37.1074V73.1965Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.1445 73.1965H37.1074V79.2336H43.1445V73.1965Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.514 73.1965H97.4766V79.2336H103.514V73.1965Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 73.1965H115.588V79.2336H121.625V73.1965Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.662 73.1965H121.625V79.2336H127.662V73.1965Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 73.1965H127.662V79.2336H133.699V73.1965Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.736 73.1965H133.699V79.2336H139.736V73.1965Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.773 73.1965H139.736V79.2336H145.773V73.1965Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.81 73.1965H145.773V79.2336H151.81V73.1965Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 73.1965H151.811V79.2336H157.848V73.1965Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.996 79.2333H12.959V85.2703H18.996V79.2333Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0331 79.2333H18.9961V85.2703H25.0331V79.2333Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 79.2334H25.0332V85.2704H31.0702V79.2334Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 79.2334H43.1445V85.2704H49.1816V79.2334Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2558 79.2334H55.2188V85.2704H61.2558V79.2334Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 79.2334H61.2559V85.2704H67.2929V79.2334Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.33 79.2334H67.293V85.2704H73.33V79.2334Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 79.2334H91.4395V85.2704H97.4765V79.2334Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 79.2334H103.514V85.2704H109.551V79.2334Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 79.2334H115.588V85.2704H121.625V79.2334Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.662 79.2334H121.625V85.2704H127.662V79.2334Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 79.2333H151.811V85.2703H157.848V79.2333Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 85.2706H6.92188V91.3077H12.9589V85.2706Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.996 85.2706H12.959V91.3077H18.996V85.2706Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 85.2708H31.0703V91.3078H37.1074V85.2708Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.1445 85.2708H37.1074V91.3078H43.1445V85.2708Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.2187 85.2708H49.1816V91.3078H55.2187V85.2708Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 85.2708H61.2559V91.3078H67.2929V85.2708Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.33 85.2708H67.293V91.3078H73.33V85.2708Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4042 85.2708H79.3672V91.3078H85.4042V85.2708Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.514 85.2708H97.4766V91.3078H103.514V85.2708Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 85.2708H127.662V91.3078H133.699V85.2708Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.81 85.2706H145.773V91.3077H151.81V85.2706Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 91.3076H6.92188V97.3447H12.9589V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.996 91.3076H12.959V97.3447H18.996V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 91.3076H25.0332V97.3447H31.0702V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 91.3076H31.0703V97.3447H37.1074V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 91.3076H43.1445V97.3447H49.1816V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.2187 91.3076H49.1816V97.3447H55.2187V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2558 91.3076H55.2188V97.3447H61.2558V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 91.3076H61.2559V97.3447H67.2929V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.4394 91.3076H85.4023V97.3447H91.4394V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.514 91.3076H97.4766V97.3447H103.514V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.588 91.3076H109.551V97.3447H115.588V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 91.3076H127.662V97.3447H133.699V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.736 91.3076H133.699V97.3447H139.736V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.773 91.3076H139.736V97.3447H145.773V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.81 91.3076H145.773V97.3447H151.81V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 91.3076H151.811V97.3447H157.848V91.3076Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 97.3447H6.92188V103.382H12.9589V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0331 97.3447H18.9961V103.382H25.0331V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 97.3447H25.0332V103.382H31.0702V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 97.3447H31.0703V103.382H37.1074V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.2187 97.3447H49.1816V103.382H55.2187V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2558 97.3447H55.2188V103.382H61.2558V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 97.3447H61.2559V103.382H67.2929V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4042 97.3447H79.3672V103.382H85.4042V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 97.3447H91.4395V103.382H97.4765V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.514 97.3447H97.4766V103.382H103.514V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 97.3447H103.514V103.382H109.551V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 97.3447H115.588V103.382H121.625V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.662 97.3447H121.625V103.382H127.662V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.773 97.3447H139.736V103.382H145.773V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 97.3447H151.811V103.382H157.848V97.3447Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 103.382H6.92188V109.419H12.9589V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0331 103.382H18.9961V109.419H25.0331V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 103.382H25.0332V109.419H31.0702V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 103.382H31.0703V109.419H37.1074V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 103.382H43.1445V109.419H49.1816V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.2187 103.382H49.1816V109.419H55.2187V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.3671 103.382H73.3301V109.419H79.3671V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4042 103.382H79.3672V109.419H85.4042V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.4394 103.382H85.4023V109.419H91.4394V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 103.382H103.514V109.419H109.551V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.588 103.382H109.551V109.419H115.588V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 103.382H115.588V109.419H121.625V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.662 103.382H121.625V109.419H127.662V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 103.382H127.662V109.419H133.699V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.773 103.382H139.736V109.419H145.773V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.81 103.382H145.773V109.419H151.81V103.382Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2558 109.419H55.2188V115.456H61.2558V109.419Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 109.419H61.2559V115.456H67.2929V109.419Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.33 109.419H67.293V115.456H73.33V109.419Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.3671 109.419H73.3301V115.456H79.3671V109.419Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 109.419H91.4395V115.456H97.4765V109.419Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 109.419H103.514V115.456H109.551V109.419Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 109.419H127.662V115.456H133.699V109.419Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.81 109.419H145.773V115.456H151.81V109.419Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 115.456H6.92188V121.493H12.9589V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.996 115.456H12.959V121.493H18.996V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0331 115.456H18.9961V121.493H25.0331V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 115.456H25.0332V121.493H31.0702V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 115.456H31.0703V121.493H37.1074V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.1445 115.456H37.1074V121.493H43.1445V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 115.456H43.1445V121.493H49.1816V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 115.456H61.2559V121.493H67.2929V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.33 115.456H67.293V121.493H73.33V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4042 115.456H79.3672V121.493H85.4042V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 115.456H91.4395V121.493H97.4765V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 115.456H103.514V121.493H109.551V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 115.456H115.588V121.493H121.625V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 115.456H127.662V121.493H133.699V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.736 115.456H133.699V121.493H139.736V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 115.456H151.811V121.493H157.848V115.456Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 121.493H6.92188V127.53H12.9589V121.493Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 121.493H43.1445V127.53H49.1816V121.493Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.33 121.493H67.293V127.53H73.33V121.493Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.3671 121.493H73.3301V127.53H79.3671V121.493Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.4394 121.493H85.4023V127.53H91.4394V121.493Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.514 121.493H97.4766V127.53H103.514V121.493Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 121.493H103.514V127.53H109.551V121.493Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 121.493H127.662V127.53H133.699V121.493Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 121.493H151.811V127.53H157.848V121.493Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 127.53H6.92188V133.567H12.9589V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0331 127.53H18.9961V133.567H25.0331V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 127.53H25.0332V133.567H31.0702V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 127.53H31.0703V133.567H37.1074V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 127.53H43.1445V133.567H49.1816V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2558 127.53H55.2188V133.567H61.2558V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 127.53H61.2559V133.567H67.2929V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.3671 127.53H73.3301V133.567H79.3671V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4042 127.53H79.3672V133.567H85.4042V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 127.53H91.4395V133.567H97.4765V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.514 127.53H97.4766V133.567H103.514V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 127.53H103.514V133.567H109.551V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.588 127.53H109.551V133.567H115.588V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 127.53H115.588V133.567H121.625V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.662 127.53H121.625V133.567H127.662V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 127.53H127.662V133.567H133.699V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.736 127.53H133.699V133.567H139.736V127.53Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 133.567H6.92188V139.604H12.9589V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0331 133.567H18.9961V139.604H25.0331V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 133.567H25.0332V139.604H31.0702V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 133.567H31.0703V139.604H37.1074V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 133.567H43.1445V139.604H49.1816V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2558 133.567H55.2188V139.604H61.2558V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 133.567H61.2559V139.604H67.2929V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.33 133.567H67.293V139.604H73.33V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4042 133.567H79.3672V139.604H85.4042V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 133.567H91.4395V139.604H97.4765V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.588 133.567H109.551V139.604H115.588V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 133.567H115.588V139.604H121.625V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.736 133.567H133.699V139.604H139.736V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.81 133.567H145.773V139.604H151.81V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 133.567H151.811V139.604H157.848V133.567Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 139.604H6.92188V145.641H12.9589V139.604Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0331 139.604H18.9961V145.641H25.0331V139.604Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 139.604H25.0332V145.641H31.0702V139.604Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 139.604H31.0703V145.641H37.1074V139.604Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 139.604H43.1445V145.641H49.1816V139.604Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.3671 139.604H73.3301V145.641H79.3671V139.604Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 139.604H103.514V145.641H109.551V139.604Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.588 139.604H109.551V145.641H115.588V139.604Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.662 139.604H121.625V145.641H127.662V139.604Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 139.604H127.662V145.641H133.699V139.604Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.773 139.604H139.736V145.641H145.773V139.604Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.81 139.604H145.773V145.641H151.81V139.604Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 139.604H151.811V145.641H157.848V139.604Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 145.641H6.92188V151.678H12.9589V145.641Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 145.641H43.1445V151.678H49.1816V145.641Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2558 145.641H55.2188V151.678H61.2558V145.641Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2929 145.641H61.2559V151.678H67.2929V145.641Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4765 145.641H91.4395V151.678H97.4765V145.641Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.588 145.641H109.551V151.678H115.588V145.641Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.662 145.641H121.625V151.678H127.662V145.641Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.699 145.641H127.662V151.678H133.699V145.641Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.773 145.641H139.736V151.678H145.773V145.641Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.81 145.641H145.773V151.678H151.81V145.641Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 145.641H151.811V151.678H157.848V145.641Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9589 151.678H6.92188V157.715H12.9589V151.678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.996 151.678H12.959V157.715H18.996V151.678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.0331 151.678H18.9961V157.715H25.0331V151.678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.0702 151.678H25.0332V157.715H31.0702V151.678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1074 151.678H31.0703V157.715H37.1074V151.678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.1445 151.678H37.1074V157.715H43.1445V151.678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1816 151.678H43.1445V157.715H49.1816V151.678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2558 151.678H55.2188V157.715H61.2558V151.678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.33 151.678H67.293V157.715H73.33V151.678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.3671 151.678H73.3301V157.715H79.3671V151.678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4042 151.678H79.3672V157.715H85.4042V151.678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.551 151.678H103.514V157.715H109.551V151.678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.625 151.678H115.588V157.715H121.625V151.678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.736 151.678H133.699V157.715H139.736V151.678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.848 151.678H151.811V157.715H157.848V151.678Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_549_2105"
}, /*#__PURE__*/React.createElement("rect", {
  width: 164,
  height: 164,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMobileApplicationQrCode);
export default ForwardRef;